import React, { useEffect, useMemo, useState } from "react";
import {
  FormSections,
  ProgramContainer,
} from "../../entities/formTemplateDataType";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import axios from "axios";
import DataUtils from "../../utilities/DataUtils";
import ReCaptchaV3 from "../captcha/CaptchComponent";
import ReCaptchaButton from "../captcha/captcha-button";
import SectionUtils from "../../utilities/SectionUtils";
import { getEnvVar } from "../../config/RuntimeConfig";

interface Props {
  token: string;
  programContainer: ProgramContainer;
  isEng: boolean;
  section: FormSections;
  onButtonClick: (data) => void;
  callbackStepIndex?: (index: number, returnIndex?: number) => void;
}

const LibPubHandleSubmitComponent: React.FC<Props> = ({
  programContainer,
  isEng,
  section,
  onButtonClick,
  callbackStepIndex,
}) => {
  const [validationErrMsg, setValidationErrMsg] = useState<any[]>([]);
  const [isBusy, setIsBusy] = useState<boolean>(false);
  const [confirmationVisible, setConfirmationVisible] = useState<boolean>(false);
  const [summaryVisible, setSummaryVisible] = useState<boolean>(true);
  const [submissionError, setSubmissionError] = useState<boolean>(false);
  const [transactionId, setTransactionId] = useState<string>("");

  const cleanupAfterSubmit = () => {
    if (!programContainer.ClearFormAfterSubmit) {
      return;
    }
    DataUtils.clearFormValue(programContainer);
    SectionUtils.resetDirtyFlags(programContainer);
  };

  const handleSubmitNoRecaptha = () => {
    handleSubmit(null);
  };

  const buildPayload = (data: any, token: string) => {
    const contactInfo = data["contact-info"]?.[0] || {};
    console.log('query',  contactInfo,data);
    const contactInformation = {
      first_name: data.First__name || "",
      last_name: data.Last__name || "",
      organization: data.Organization || "",
      email_address: data.Email__address || "",
      phone_number: data.Phone__number || "",
    };

    const libraryItems = data["Library-item"] || [];
    const requestItems = libraryItems.map((item: any) => ({
      title: item.Title || "",
      call_number: item.Call__number || "",
      volume_number: item.Volume__number || "",
      permalink_url: item.Permalink__URL || "",
      additional_information:
        item["Is__there__any__other__information__you__want__to__include?"] || "",
    }));

    const payload: any = {
      contact_information: contactInformation,
      requests: [
        {
          requesttype: "100000000",
          retrievaltype: "100000001",
          requestitems: requestItems,
        },
      ],
    };


    // if (token) {
    //   payload.token = token;
    // }

    return payload;
  };

  const handleSubmit = (token: string) => {
    const invalidControlList = FormValidationUtils.invalidControls(section);
    if (invalidControlList.length > 0) {
      setValidationErrMsg(invalidControlList);
      window.scrollTo(0, 0);
    } else {
      let url = programContainer.UpdateAPI;
      const data = DataUtils.collectFormValue(programContainer);
      const updateToken = programContainer.Profile?.token;

      const headers: Record<string, string> = {
        "Content-Type": "application/json",
      };
      if (updateToken) {
        headers["Authorization"] = `Bearer ${updateToken}`;
      }

      const payload = buildPayload(data, token);

      console.log("Library-Publication payload:", payload);

      setIsBusy(true);

      axios
        .post(url, payload, { headers })
        .then((res) => {
          console.log(res);
          setIsBusy(false);
          setConfirmationVisible(true);
          setSummaryVisible(false);
          setTransactionId(
            res.data?.transactionId ||
              res.data?.WebResponse?.transactionId ||
              ""
          );
          DataUtils.clearDraft(
            programContainer.CategoryId,
            programContainer.Profile?.email,
            programContainer.draftId,
          );
          programContainer.draftId = undefined;
          cleanupAfterSubmit();
        })
        .catch((err) => {
          setIsBusy(false);
          setSummaryVisible(false);
          setSubmissionError(true);
          console.log(err);
        });
    }
  };

  const props = useMemo(
    () => ({
      isBusy,
      confirmationVisible,
      summaryVisible,
      submissionError,
      validationErrMsg,
      transactionId,
    }),
    [isBusy, validationErrMsg, transactionId],
  );

  useEffect(() => {
    onButtonClick(props);
  }, [props]);

  console.log('library submit button rendered');

  return (
    <div className="ontario-margin-top-24-!">
      {getEnvVar("DISABLED_RECAPTCHA") == "false" && (
        <ReCaptchaV3 lang={isEng ? "en" : "fr"}>
          <ReCaptchaButton
            key={"recaptchbutton"}
            title={isEng ? "Submit" : "Soumettre"}
            action="submitLibPub"
            buttonHandler={handleSubmit}
          >
            {isEng ? "Submit" : "Soumettre"}
          </ReCaptchaButton>
        </ReCaptchaV3>
      )}
      {getEnvVar("DISABLED_RECAPTCHA") == "true" && (
        <button
          onClick={handleSubmitNoRecaptha}
          className="ontario-button ontario-button--primary"
        >
          {isEng ? "Submit" : "Soumettre"}
        </button>
      )}
    </div>
  );
};

export default LibPubHandleSubmitComponent;
